export const REF_IDS = {
  LAYOUT: 'layout',
  AVAILABLE_PLANS: 'availablePlans',
  CONNECTIONS: 'connections',
};
